import React from 'react';

const DaohuuLayoutComponent = ({ currentSuggestion, showClose, onChange }) => {
    // Nếu không có dữ liệu, trả về null hoặc placeholder
    if (!currentSuggestion) {
        return (
            <div
                style={{
                    padding: '10px 12px',
                    background: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    color: '#9ca3af',
                    fontSize: '12px',
                    fontStyle: 'italic',
                    textAlign: 'center',
                    height: '52px', // Cùng chiều cao với component có dữ liệu
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                Chưa có thông tin
            </div>
        );
    }

    return (
        <div
            className="selected-user-display"
            style={{
                display: 'flex',
                alignItems: 'center',
                padding: showClose ? '10px 6px 10px 12px' : '10px 12px',
                background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.2s ease',
                height: '52px', // Chiều cao cố định
                width: '100%'
            }}
        >
            {/* Avatar with enhanced styling */}
            <div style={{ position: 'relative', marginRight: '10px', flexShrink: 0 }}>
                {currentSuggestion.image ? (
                    <img
                        src={currentSuggestion.image}
                        alt={currentSuggestion.ten}
                        style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            border: '2px solid #ffffff',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                        }}
                        onError={(e) => {
                            e.target.style.display = 'none';
                            // Hiển thị avatar mặc định khi ảnh lỗi
                            const defaultAvatar = e.target.nextElementSibling;
                            if (defaultAvatar) {
                                defaultAvatar.style.display = 'flex';
                            }
                        }}
                    />
                ) : null}

                {/* Default avatar - hiển thị khi không có ảnh hoặc ảnh lỗi */}
                <div
                    style={{
                        width: '28px',
                        height: '28px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                        display: currentSuggestion.image ? 'none' : 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '12px',
                        fontWeight: '600',
                        boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
                        position: currentSuggestion.image ? 'absolute' : 'static',
                        top: currentSuggestion.image ? 0 : 'auto',
                        left: currentSuggestion.image ? 0 : 'auto'
                    }}
                >
                    {currentSuggestion.ten?.charAt(0)?.toUpperCase() || 'U'}
                </div>

                {/* Online status indicator */}
                <div
                    style={{
                        position: 'absolute',
                        bottom: '-2px',
                        right: '-2px',
                        width: '10px',
                        height: '10px',
                        background: '#10b981',
                        borderRadius: '50%',
                        border: '2px solid white'
                    }}
                />
            </div>

            {/* User info - 2 dòng cố định */}
            <div style={{ flex: 1, minWidth: 0, marginRight: showClose ? '4px' : '0' }}>
                {/* Dòng 1: Tên */}
                <div
                    style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#1f2937',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: '1.2',
                        marginBottom: '2px'
                    }}
                    title={currentSuggestion.ten} // Tooltip để xem tên đầy đủ
                >
                    {currentSuggestion.ten}
                </div>

                {/* Dòng 2: Mã số hiệu - Năm sinh */}
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        lineHeight: '1.2'
                    }}
                >
                    {currentSuggestion.ma && (
                        <span
                            style={{
                                fontSize: '9px',
                                fontWeight: '700',
                                color: '#1f2937',
                                background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                                padding: '1px 4px',
                                borderRadius: '3px',
                                border: '1px solid #f59e0b',
                                boxShadow: '0 1px 3px rgba(245, 158, 11, 0.2)',
                                lineHeight: '1',
                                display: 'inline-block',
                                whiteSpace: 'nowrap'
                            }}
                        >
              {currentSuggestion.ma}
            </span>
                    )}

                    {currentSuggestion.ngay_sinh && (
                        <span
                            style={{
                                fontSize: '11px',
                                color: '#6b7280',
                                fontWeight: '400',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '3px'
                            }}
                        >
              <i className="fas fa-calendar-alt" style={{ fontSize: '9px' }}></i>
                            {currentSuggestion.ngay_sinh}
            </span>
                    )}
                </div>
            </div>

            {/* Close button - chỉ hiển thị khi showClose = true */}
            {showClose && (
                <button
                    type="button"
                    onClick={() => onChange && onChange(null)}
                    style={{
                        width: '18px',
                        height: '18px',
                        borderRadius: '4px',
                        border: 'none',
                        background: 'rgba(239, 68, 68, 0.1)',
                        color: '#ef4444',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        flexShrink: 0
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.background = '#ef4444';
                        e.target.style.color = 'white';
                        e.target.style.transform = 'scale(1.1)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = 'rgba(239, 68, 68, 0.1)';
                        e.target.style.color = '#ef4444';
                        e.target.style.transform = 'scale(1)';
                    }}
                    title="Xóa lựa chọn"
                >
                    <i className="fas fa-times" style={{ fontSize: '8px' }}></i>
                </button>
            )}
        </div>
    );
};

export default DaohuuLayoutComponent;